export default __webpack_public_path__ + "static/media/Fall_00.6cb61e16.png";